import { Container } from './styles'
import { Hero } from '../Hero/Hero'
import { About } from '../About/About'
import { Contact } from '../Contact/Contact'
import { Project } from '../Project/Project'
import { Visuals } from '../Visuals/Visuals'
import { ThemeToggle } from '../ThemeToggle'

export function Main() {
  return (
    <Container>
      <ThemeToggle />
      <Hero />
      <About />
      <Project />
      <Visuals />
      <Contact />
    </Container>
  )
}
